export default {
  id: 156,
  title: 'Target #156 - Chinese Checkers',
  url: 'https://cssbattle.dev/play/156',
  colors: ['#926927', '#F8B140'],
  solution:
    '<a><style>body{background:#926927}a{position:fixed;top:40;left:190;width:20;height:20;border-radius:9in;background:#f8b140;color:#f8b140;box-shadow:-15px 25px,15px 25px,-90px 50px,-60px 50px,-30px 50px,0 50px,30px 50px,60px 50px,90px 50px,-75px 75px,-45px 75px,-15px 75px,15px 75px,45px 75px,75px 75px,-60px 100px,-30px 100px,0 100px,30px 100px,60px 100px,-75px 125px,-45px 125px,-15px 125px,15px 125px,45px 125px,75px 125px,-90px 150px,-60px 150px,-30px 150px,0 150px,30px 150px,60px 150px,90px 150px,-15px 175px,15px 175px,0 200px}</style>',
}
